
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { IRadioOption } from 'app/interfaces/IRadioOption';

export const writeBehaviorOptionValues = {
    insert: 'insert',
    upsert: 'upsert',
    merge: 'merge',
    upload: 'upload',
    update: 'update',
    storedProcedure: 'storedProcedure',
    SCD2: 'SCD2'
};
export type writeBehaviorOptionValueTyping = typeof writeBehaviorOptionValues[keyof typeof writeBehaviorOptionValues];

export const writeBehaviorAllOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.WriteBehavior_Option_Insert,
        value: writeBehaviorOptionValues.insert
    },
    {
        label: stringResources.WriteBehavior_Option_Upsert,
        value: writeBehaviorOptionValues.upsert
    },
    {
        label: stringResources.MergeLabel,
        value: writeBehaviorOptionValues.merge
    },
    {
        label: stringResources.WriteBehavior_Option_Upload,
        value: writeBehaviorOptionValues.upload
    },
    {
        label: stringResources.Update,
        value: writeBehaviorOptionValues.update
    }
];

export const writeBehaviorRadioOptions: Array<IRadioOption<string>> = [
    {
        label: stringResources.WriteBehavior_Option_Insert,
        value: writeBehaviorOptionValues.insert
    },
    {
        label: stringResources.WriteBehavior_Option_Upsert,
        value: writeBehaviorOptionValues.upsert
    },
    {
        label: stringResources.StoredProcedure,
        value: writeBehaviorOptionValues.storedProcedure
    }
];
